import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import SpecificationsTable from "./SpecificationsTable";
import AddSpecifications from "./AddSpecifications";
import { useParams } from "react-router-dom";
import AddSpecificationValueByExcel from "./specificationvaluebyexcal";

const Specifications = () => {
  const { id } = useParams();
  const [searchText, setSearchText] = useState("");
  const [isAddModalOpen, setIsModalOpen] = useState(false);
  const [rowData, setRowData] = useState();

  const handleAddModalOpen = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="p-2 text-xl font-bold text-black font">
        Specifications
      </div>
      <div className="flex flex-col m-2 text-black rounded bg-slate-100 shadow-card shadow-zinc-600 ">
        <div className="flex flex-row items-center justify-between p-2">
          <input
            value={searchText}
            placeholder="Search"
            sx={{ borderRadius: "0.375rem" }}
            onChange={(e) => setSearchText(e.target.value)}
            className="px-2 py-1 ml-1 bg-white border border-black rounded-md"
          />

          <div className=" flex items-center gap-3">

            <AddSpecificationValueByExcel />


            <Button
              className="flex flex-row items-center "
              sx={{ background: "white", border: "1px solid black" }}
              onClick={handleAddModalOpen}
            >
              <Add /> Add Specifications
            </Button>
          </div>
        </div>
        <AddSpecifications
          open={isAddModalOpen}
          rowData={rowData}
          setOpen={setIsModalOpen}
          setRowData={setRowData}
        />
        <SpecificationsTable
          id={id}
          search={searchText}
          setIsModalOpen={setIsModalOpen}
          setRowData={setRowData}
        />
      </div>
    </>
  );
};

export default Specifications;
